exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-2slR1{background-color:#001240;height:100px;overflow-y:auto;padding:10px;white-space:pre-wrap}.theme-dark .content-2slR1{background-color:#001240}.theme-light .content-2slR1{background-color:#eaf6ff}", ""]);

// exports
exports.locals = {
	"content": "content-2slR1"
};